












































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiStaffLists, apiWorkerTypeList } from '@/api/staff'

@Component
export default class ScheduleEdit extends Vue {
    form: any = {
      staff_id: null,
      schedule_date: null,
      shift_type: 1,
      start_time: '09:00',
      end_time: '18:00',
      worker_type_id: '',
      work_area: [],
      max_orders: 3,
      is_rest_day: 0,
      leave_type: null,
      leave_reason: '',
      leave_duration: 0,
      schedule_status: 1,
      remark: ''
    }

    rules = {
      staff_id: [
        { required: true, message: '请选择员工', trigger: 'change' }
      ],
      schedule_date: [
        { required: true, message: '请选择排班日期', trigger: 'change' }
      ],
      shift_type: [
        { required: true, message: '请选择班次类型', trigger: 'change' }
      ],
      timeRange: [
        { required: true, message: '请选择工作时间', trigger: 'change' }
      ]
    }

    loading = false
    staffList: any[] = []
    workerTypeList: any[] = []

    get isEdit () {
      return this.$route.query.id
    }

    get alertTitle () {
      return this.isEdit
        ? '温馨提示：编辑排班信息，修改后会影响员工的工作安排和薪酬计算。'
        : '温馨提示：新增排班需要选择员工、日期、班次、工作时间等基本信息。'
    }

    datePickerOptions = {
      disabledDate (time: any) {
        // 只能选择今天及以后的日期
        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
      }
    }

    handleSubmit () {
      (this.$refs.formRef as any).validate((valid: boolean) => {
        if (valid) {
          this.loading = true

          // 处理表单数据
          const submitData = {
            ...this.form,
            work_area: JSON.stringify(this.form.work_area),
            schedule_date: this.form.schedule_date ? Math.floor(this.form.schedule_date / 1000) : null
          }

          // 这里调用API保存数据
          console.log('保存排班数据:', submitData)

          // 模拟API调用
          setTimeout(() => {
            this.loading = false
            this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
            this.$router.push('/staff/schedule')
          }, 1000)
        }
      })
    }

    getStaffList () {
      apiStaffLists({ page: 1, size: 1000 }).then((res: any) => {
        this.staffList = res.lists || []
      })
    }

    getWorkerTypeList () {
      apiWorkerTypeList().then((res: any) => {
        this.workerTypeList = res.lists || []
      })
    }

    created () {
      this.getStaffList()
      this.getWorkerTypeList()

      // 设置默认排班日期为明天
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      if (!this.isEdit) {
        this.form.schedule_date = tomorrow.getTime()
      }
    }
}
